module.exports = __webpack_public_path__ + "img/fr.61406a35.svg";